import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";

const departmentOverview = {
  paragraphs: [""],
};

const facultyOrder = [];

const facultyData = {
  hod: null,
  members: facultyOrder,
};

export const programme = {
  id: "english",
  name: "English",
  short: "English",
  programmeType: "ug",
  programmeLabel: "",
  duration: "First-year engineering foundation",
  intake: "510+",
  established: 2004,
  description:
    "The Department of English develops communication skills, professional English, presentation ability, technical writing, teamwork, and confidence for first-year engineering students.",
  departmentOverview,
  dashboard: [
    ["Faculty Members", "03"],
    ["Faculty with Ph.D.", "03"],
    ["Laboratories", "01"],
    ["Students Enrolled", "510+"],
  ],
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The department has experienced faculty, modern laboratories, and strong mentoring support.Students consistently perform well in VTU examinations and engage in research activities.Industry interaction, value education, and professional ethics support overall development",
    },
     {
      title: "Practical Learning and Innovation",
      text: "The department combines classroom learning with Engineering Physics laboratory practice, demonstrations, and applied experiments.",
    },
    {
      title: "Beyond Syllabus",
      text: "Students connect physics foundations with materials, electronics, optics, computational methods, and emerging engineering applications.",
    },
  ],
  image:
    "/Campus/english.jpg",
  facultyDeptId: "bsh",
  facultyData,
  labs: ["Language Lab"],
  research:
    "Communication Skills · Technical Writing · Professional English · Presentation Practice",
  accreditation: [
    "VTU-affiliated first-year curriculum",
    "AICTE-approved engineering programme support",
  ],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        { label: "English Achievements", href: "#" },
      ],
    },
  ],
  projects: [],
};

const English = () => <ProgrammeDetail programme={programme} />;

export default English;
